export default {
  methods: {
    generateRandomId(prefix = '') {
      return prefix + Math.random().toString(36).substring(2, 9);
    },
  },
};
